// extracted by mini-css-extract-plugin
export default {"patientsContainer":"Patients_patientsContainer__ZnSRb","filters":"Patients_filters__fRBKl","details":"Patients_details__Ex5+f"};